module.exports = __webpack_public_path__ + "static/telecommute-small-card-51a74a3d84677f6fb0ac4aaea8cb8c54.png";